import BasicModel from '../basic/BasicModel'
export default {
  findCarCoinRecordsByLcwUserId(vm, params, listener) {
    let action = 'user/findCarCoinRecordsByLcwUserId.action'
    BasicModel.get(vm, action, params, listener)
  },
  changeAuditStatus(vm, params, listener) {
    let action = 'lcwWithdraw/changeAuditStatus.action'
    BasicModel.post(vm, action, params, listener)
  },
  batchAuditing(vm, params, listener) {
    let action = 'lcwWithdraw/batchAuditing.action'
    BasicModel.post(vm, action, params, listener)
  },
  disposeTemporary(vm, params, listener) {
    let action = 'lcwWithdraw/disposeTemporary.action'
    BasicModel.post(vm, action, params, listener)
  },
  findWithdrawMoneyRecord(vm, params, listener) {
    let action = 'lcwWithdraw/findWithdrawMoneyRecord.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectTaskConfig(vm, listener) {
    let action = 'lcwtask/selectTaskConfig.action'
    BasicModel.get(vm, action, null, listener)
  },
  saveTaskConfig(vm, params, listener) {
    let action = 'lcwtask/saveTaskConfig.action'
    BasicModel.post(vm, action, params, listener)
  },
  findUserInviteDetail(vm,params,listener){
    let action = 'user/findUserInviteDetail.action'
    BasicModel.get(vm, action, params, listener)
  },
  findUserBrowseRecordDetail: function(vm,params,listener){
    let action = 'user/findUserBrowseRecordDetail.action'
    BasicModel.get(vm, action, params, listener)
  },
  selectWithdrawMoneyRecordInfo: function(vm,params,listener){
    let action = 'lcwWithdraw/selectWithdrawMoneyRecordInfo.action'
    BasicModel.get(vm, action, params, listener)
  },


}
